import { render, staticRenderFns } from "./tabDocumentsTypes.vue?vue&type=template&id=7b1a3f5a&scoped=true"
import script from "./tabDocumentsTypes.vue?vue&type=script&lang=js"
export * from "./tabDocumentsTypes.vue?vue&type=script&lang=js"
import style0 from "./tabDocumentsTypes.vue?vue&type=style&index=0&id=7b1a3f5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b1a3f5a",
  null
  
)

export default component.exports